module.exports = __webpack_public_path__ + "media/images/new-deal-hover-87ecf231ad94652dee7822ceb5efabbe.png";